import { ApiBase } from '../ApiBase';
class PlatformAppsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getPlatformApps = () => {
            return this.get('/platformapps');
        };
        this.getPlatformApp = (params, query) => {
            return this.get(`/platformapps/${params.appId}`, query);
        };
        this.connectPlatformApp = (params, body) => {
            return this.post(`/platformapps/${params.appId}`, body);
        };
        this.disconnectPlatformApp = (params) => {
            return this.delete(`/platformapps/${params.appId}`);
        };
        this.getPlatformAppClients = () => {
            return this.get('/platformapps/clients');
        };
        this.getPlatformAppClient = (params) => {
            return this.get(`/platformapps/clients/${params.clientId}`);
        };
        this.createPlatformAppClient = (body) => {
            return this.post('/platformapps/clients', body);
        };
        this.deletePlatformAppClient = (params) => {
            return this.delete(`/platformapps/clients/${params.clientId}`);
        };
        this.updatePlatformAppClientDetails = (params, body) => {
            return this.put(`/platformapps/clients/${params.clientId}/details`, body);
        };
        this.updatePlatformAppClientScopes = (params, body) => {
            return this.put(`/platformapps/clients/${params.clientId}/scopes`, body);
        };
        this.updatePlatformAppClientRedirectUris = (params, body) => {
            return this.put(`/platformapps/clients/${params.clientId}/redirect-uris`, body);
        };
        this.updatePlatformAppClientIcon = (params, file) => {
            const formData = new FormData();
            formData.append('file', file);
            return this.post(`/platformapps/clients/${params.clientId}/icon`, formData);
        };
        this.getPlatformAppClientSecret = (pathParams) => {
            return this.get(`/platformapps/clients/${pathParams.clientId}/secret`);
        };
        this.createPlatformAppClientSection = (pathParams, body) => {
            return this.post(`/platformapps/clients/${pathParams.appId}/sections`, body);
        };
        this.updatePlatformAppClientSection = (pathParams, body) => {
            return this.put(`/platformapps/clients/${pathParams.appId}/sections/${pathParams.sectionId}`, body);
        };
        this.deletePlatformAppClientSection = (pathParams) => {
            return this.delete(`/platformapps/clients/${pathParams.appId}/sections/${pathParams.sectionId}`);
        };
        this.changePlatformAppStatus = (pathParams, body) => {
            return this.put(`/platformapps/clients/${pathParams.clientId}/status`, body);
        };
        this.publishPlatformApp = (pathParams) => {
            return this.put(`/platformapps/clients/${pathParams.clientId}/publish`);
        };
        this.unpublishPlatformApp = (pathParams) => {
            return this.put(`/platformapps/clients/${pathParams.clientId}/unpublish`);
        };
        this.refreshPlatformApp = (pathParams) => {
            return this.post(`/platformapps/clients/${pathParams.clientId}/refresh`);
        };
    }
}
export const PlatformAppsApiClient = new PlatformAppsApiClientModel();
